import React from 'react';

const Divider = () => {
  return <div className="brick-divider"></div>;
};

export default Divider;

